export enum ADDRESS_TYPE {
  BILLING = 'billing',
  SHIPPING = 'shipping',
  PICKUP = 'pickupStation'
}
